import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';
import {
  actionTypes,
} from '../actions';

import {
  throwError,
} from './helpers';
import api from '../api';

export default function* personalWorkoutFlow() {
  function* fetchWorkouts(request = {}) {
    const { params = {}, userId } = request;
    const actions = createActionCreators('read', {
      resourceType: 'personalWorkouts',
      requestKey: 'fetchPersonalWorkouts',
    });
    const requestParams = {
      qs: {
        ...params,
      },
      userId,
    };

    try {
      yield eff.put(actions.pending());
      const personalWorkouts = yield eff.call(
        api.getPersonalWorkouts,
        requestParams,
      );
      yield eff.put(actions.succeeded({
        resources: personalWorkouts,
        list: userId.toString(),
      }));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }

  function* fetchWorkoutEvents(request = {}) {
    const { id, params = {} } = request as any;
    const actions = createActionCreators('read', {
      resourceType: 'workoutEvents',
      requestKey: 'fetchPersonalWorkoutEvents',
    });

    try {
      yield eff.put(actions.pending());
      const workoutEvents = yield eff.call(
        api.getEntityInternals,
        {
          id,
          type: 'personal_workouts',
          endpoint: 'workout_events',
          qs: {
            ...params,
          },
        },
      );
      yield eff.put(actions.succeeded({
        resources: workoutEvents,
        list: `personal_workout_${id}`,
      }));
    } catch (err) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, err);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_LOAD_PERSONAL_WORKOUTS, fetchWorkouts);
  yield eff.takeEvery(actionTypes.REQUEST_LOAD_PERSONAL_WORKOUT_EVENTS, fetchWorkoutEvents);
}
